import { render, staticRenderFns } from "./EditLossForm.vue?vue&type=template&id=6b4e58a4"
import script from "./EditLossForm.vue?vue&type=script&lang=ts"
export * from "./EditLossForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports